var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZorgverzekeringOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.93 199.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #37474f;\n      }\n\n      .cls-3 {\n        fill: #455a64;\n      }\n\n      .cls-4 {\n        fill: #a6a6a6;\n      }\n\n      .cls-5 {\n        fill: #ffc727;\n      }\n\n      .cls-6, .cls-7 {\n        opacity: .1;\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n\n      .cls-8 {\n        fill: #263238;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4.32,
    y: 2.64,
    width: 168.26,
    height: 197.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 141.04,
    y: 21.39,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.96,
    y: 14.76,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 134.11,
    y: 14.76,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 23.47,
    y: 14.76,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16.55,
    y: 157.11,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 147.96,
    y: 163.73,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 121.01,
    y: 76.82,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 114.09,
    y: 83.44,
    width: 12.41,
    height: 5.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 62.9,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 62.9,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 35,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 35,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.32,
    y: 40.3,
    width: 168.26,
    height: 22.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 194.58,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 194.58,
    width: 176.93,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 124.39,
    y: 72.81,
    width: 42.02,
    height: 23.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.41 72.81 166.41 84.11 153.93 96.6 139.95 96.6 163.73 72.81 166.41 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "150.25 72.81 126.46 96.6 124.39 96.6 124.39 95.71 147.3 72.81 150.25 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "139.89 72.81 124.39 88.31 124.39 82.53 134.1 72.81 139.89 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "166.41 88.14 166.41 93.93 163.74 96.6 157.95 96.6 166.41 88.14"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 124.39,
    y: 101.63,
    width: 42.02,
    height: 98.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 130.64,
    y: 108.04,
    width: 29.52,
    height: 48.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 108.04,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 109.58,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 111.11,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 112.64,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 114.17,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 115.71,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 117.25,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 118.79,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 120.33,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 121.86,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 123.4,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 124.94,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 126.47,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 128.01,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 129.55,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 131.09,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 132.63,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 134.16,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 135.7,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 137.24,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 138.76,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 140.3,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.64,
    y: 141.84,
    width: 29.52,
    height: 1.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.16 108.04 160.16 113.85 130.64 143.38 130.64 129.39 152 108.04 160.16 108.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.16 138.54 160.16 152.51 156.39 156.29 142.41 156.29 160.16 138.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.16 132.41 160.16 135.36 139.24 156.29 136.29 156.29 160.16 132.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.03 108.04 130.64 126.41 130.64 120.62 143.24 108.04 149.03 108.04"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 133.27,
    y: 161.74,
    width: 22.13,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 161,
    y: 158.6,
    width: 2.59,
    height: 8.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m130.64,191.67c-.09-1.41-.14-2.83-.2-4.24-.06-1.41-.1-2.84-.14-4.25-.07-2.83-.13-5.66-.15-8.49v-.49h13.81c2.21,0,4.45.09,6.66.16,1.11,0,2.22.07,3.34.13s2.22.09,3.34.16l-3.34.16c-1.11,0-2.22.1-3.34.13-2.21.07-4.44.13-6.66.15-2.22.02-4.44.06-6.66.06h-6.66l.49-.49c0,2.83-.06,5.66-.14,8.49,0,1.41-.09,2.84-.15,4.25s-.11,2.85-.2,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m160.16,174.7c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.15,4.24.07,2.84.11,5.66.15,8.49v.5h-13.96c-2.25,0-4.49-.09-6.73-.15l-3.38-.14c-1.11,0-2.24-.09-3.36-.16l3.36-.16c1.12,0,2.25-.1,3.38-.13,2.24-.07,4.49-.11,6.73-.15s4.49-.06,6.74-.06h6.73l-.49.49c0-2.83.07-5.65.15-8.49,0-1.41.07-2.83.15-4.24.07-1.41.1-2.88.19-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m134.46,188.47c-.15-1.76-.24-3.53-.31-5.29,0-.88-.06-1.76-.1-2.64s0-1.76,0-2.65v-.46h5.41c1.64,0,3.29,0,4.94.06,1.65.06,3.29.07,4.94.15,1.65.07,3.29.16,4.94.3-1.65.14-3.29.24-4.94.3s-3.29.13-4.94.16c-1.65.04-3.29,0-4.94,0h-4.94l.48-.48c0,.89,0,1.76-.06,2.65-.06.89,0,1.76-.09,2.64-.14,1.73-.2,3.49-.39,5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m156.34,177.9c.15,1.76.25,3.53.31,5.29.06,1.76.13,3.53.16,5.29v.46h-10.48c-1.67,0-3.33-.09-5-.15-1.67-.06-3.33-.18-5-.31,1.67-.14,3.33-.24,5-.3,1.67-.06,3.33-.11,5-.15,1.66,0,3.33,0,5-.06,1.67-.06,3.33,0,5,0l-.46.46c0-1.77.05-3.53.15-5.29.07-1.76.17-3.48.31-5.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11.49,
    y: 70.11,
    width: 104.36,
    height: 94.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 14.09,
    y: 72.81,
    width: 99.17,
    height: 89.03
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 133.09 113.26 147.06 98.49 161.84 84.5 161.84 113.26 133.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.22 72.81 14.09 145.95 14.09 131.98 73.25 72.81 87.22 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.94 72.81 14.09 154.66 14.09 151.71 92.99 72.81 95.94 72.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 110.6 113.26 113.55 64.96 161.84 62.02 161.84 113.26 110.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 152.4 113.26 158.18 109.6 161.84 103.81 161.84 113.26 152.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.12 72.81 14.09 119.85 14.09 114.06 55.34 72.81 61.12 72.81"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 8.24,
    y: 91.1,
    width: 0.51,
    height: 36.97,
    transform: "translate(-16.89 2.64) rotate(-8.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.4,127.84c0,.55-.45,1-1,1s-1-.45-1-1,.45-1,1-1h0c.55,0,1,.45,1,1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 100.22,
    y: 109.3,
    width: 36.97,
    height: 0.51,
    transform: "translate(-7.86 209.93) rotate(-81.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.85,127.84c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1h0c-.55,0-1,.45-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m124.65,90.95H2.72c7.3-12.65,8.75-22.75,8.75-22.75h104.43s1.43,10.1,8.75,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m124.65,90.95v2.69c.06,1.31-.95,2.43-2.26,2.5h-4.86c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.32-.95,2.44-2.27,2.5,0,0,0,0,0,0h-4.84c-1.31-.07-2.33-1.19-2.26-2.5.06,1.32-.95,2.44-2.27,2.5,0,0,0,0,0,0h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5.06,1.32-.95,2.44-2.27,2.5,0,0,0,0,0,0h-4.84c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.84c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.84c-1.32-.06-2.34-1.18-2.28-2.49,0,0,0,0,0,0,.06,1.31-.95,2.43-2.26,2.5h-4.85c-1.31-.07-2.33-1.19-2.26-2.5v-2.69h121.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.15,93.64c0-.9,0-1.8-.1-2.69v-.06c1.05-1.73,1.99-3.53,2.86-5.35.88-1.82,1.64-3.69,2.36-5.57.7-1.9,1.29-3.83,1.78-5.79l.35-1.47c.1-.5.16-1,.26-1.5.22-.99.28-2,.44-3-.05,2.03-.28,4.06-.69,6.05-.42,2-.98,3.96-1.67,5.88-.7,1.92-1.51,3.79-2.43,5.61-.45.91-.94,1.8-1.46,2.69s-1.04,1.75-1.62,2.57h0c-.08.84-.08,1.74-.08,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.47,93.64c0-.9,0-1.8-.1-2.69h0c.51-.85.99-1.73,1.44-2.61s.85-1.8,1.25-2.71c.78-1.83,1.44-3.7,1.99-5.61.16-.47.29-.95.4-1.44.11-.48.26-.96.35-1.45.2-.97.42-1.94.56-2.92.31-1.97.52-3.95.62-5.94.07,2-.01,4-.26,5.99-.51,3.99-1.61,7.89-3.25,11.56-.81,1.84-1.79,3.59-2.92,5.25h0c0,.77-.03,1.67-.08,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m58.99,93.64c-.06-2.13-.06-4.24-.06-6.36s0-4.24.07-6.36c.07-2.12.1-4.24.19-6.36l.14-3.18c.06-1.06.11-2.13.19-3.18,0,1.05,0,2.11.06,3.18v3.19c0,2.11,0,4.24-.07,6.36-.07,2.12-.11,4.24-.2,6.35-.09,2.11-.16,4.25-.31,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.4,93.64c-.15-2.11-.24-4.24-.33-6.36-.09-2.12-.13-4.24-.19-6.35-.06-2.11-.07-4.25-.07-6.36v-3.19c0-1.06,0-2.13.06-3.18.07,1.05.13,2.11.19,3.18l.14,3.18c.09,2.13.14,4.24.2,6.36.06,2.12,0,4.24.07,6.36.07,2.12-.07,4.24-.07,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.65,93.64c0-.9-.07-1.8-.11-2.69h0c.25-1.88.39-3.75.55-5.66.16-1.91.22-3.75.34-5.68.11-1.93.15-3.75.22-5.7l.16-5.69c.06.94.1,1.89.15,2.85s0,1.9,0,2.85c0,1.9,0,3.75-.09,5.7-.09,1.95-.22,3.81-.4,5.7-.09.95-.2,1.9-.33,2.84-.13.94-.26,1.89-.45,2.83h0c-.05.85-.05,1.75-.05,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.24,93.64c0-.9-.07-1.8-.11-2.69h0c.62-1.81,1.1-3.66,1.43-5.54.18-.95.33-1.89.48-2.84.15-.95.25-1.9.36-2.85.24-1.9.35-3.81.51-5.72l.18-2.87c0-.96.07-1.93.14-2.87,0,.95.06,1.91.09,2.87s0,1.93,0,2.89c0,1.93-.19,3.85-.39,5.76-.2,1.92-.49,3.83-.89,5.72-.19.94-.42,1.88-.7,2.8-.26.94-.58,1.85-.97,2.74h0c-.05.8-.08,1.7-.11,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.9,93.64c0-.9,0-1.8-.1-2.69v-.06c.84-1.75,1.55-3.56,2.1-5.42.59-1.86,1.01-3.75,1.41-5.66.4-1.91.65-3.84.88-5.77.14-.96.16-1.94.28-2.9.11-.96.1-1.95.18-2.92v4.4c0,.49,0,.97-.09,1.46l-.11,1.46c0,.5-.13.97-.19,1.46-.11.97-.29,1.94-.45,2.91-.37,1.93-.87,3.83-1.47,5.7-.3.94-.65,1.85-1.04,2.75-.36.91-.77,1.8-1.25,2.65h0c-.14.84-.14,1.74-.14,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.25,93.64c0-.9-.06-1.8-.1-2.69h0c-.59-.83-1.11-1.7-1.62-2.57s-1.01-1.78-1.46-2.69c-.91-1.81-1.71-3.66-2.41-5.56-.7-1.91-1.25-3.88-1.66-5.88-.42-1.99-.65-4.02-.69-6.05.15,1,.21,2.01.42,3,.1.5.16,1,.28,1.5l.34,1.47c.48,1.96,1.08,3.89,1.79,5.79.71,1.89,1.46,3.75,2.35,5.57.89,1.82,1.81,3.62,2.86,5.35v.06c-.01.89-.04,1.79-.09,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.9,93.64c0-.9-.07-1.8-.1-2.69h0c-1.13-1.66-2.11-3.41-2.92-5.25-.83-1.83-1.51-3.73-2.05-5.66-.57-1.93-.99-3.9-1.25-5.9-.25-1.99-.34-3.99-.26-5.99.11,1.99.32,3.97.62,5.94.15.99.37,1.95.56,2.92.1.49.24.97.35,1.45s.25.96.4,1.44c.54,1.91,1.21,3.79,1.99,5.61.4.91.8,1.82,1.25,2.71s.94,1.76,1.45,2.61v.06c-.04.94-.04,1.84-.04,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.75,93.64c0-.9-.07-1.8-.11-2.69h0c-.19-.94-.31-1.88-.45-2.83s-.24-1.89-.33-2.84c-.16-1.89-.33-3.75-.39-5.7-.06-1.95-.14-3.75-.1-5.7,0-.95,0-1.9.06-2.85s.07-1.91.14-2.85l.16,5.69c.07,1.9.13,3.75.22,5.7.1,1.95.19,3.75.35,5.68s.29,3.75.54,5.66h0c-.04.92-.05,1.82-.1,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.15,93.64c0-.9-.07-1.8-.11-2.69h0c-.39-.89-.72-1.8-.97-2.74-.26-.92-.5-1.86-.7-2.8-.39-1.89-.68-3.8-.88-5.72-.21-1.91-.35-3.84-.4-5.76v-2.89c0-.96,0-1.93.09-2.87.06.95.1,1.91.15,2.87l.16,2.87c.16,1.91.28,3.82.53,5.72.1.95.24,1.9.36,2.85.13.95.29,1.89.48,2.84.32,1.88.79,3.73,1.41,5.54h0c-.11.97-.11,1.88-.11,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m96.5,93.64c0-.9-.07-1.8-.1-2.69h0c-.48-.85-.89-1.74-1.25-2.65-.4-.9-.74-1.82-1.04-2.75-.61-1.87-1.11-3.77-1.47-5.7-.16-.97-.35-1.94-.46-2.91-.06-.49-.14-.96-.18-1.46l-.13-1.46c0-.48-.02-.97-.07-1.46v-4.4c.07.97.11,1.95.19,2.92s.14,1.94.26,2.9c.22,1.94.5,3.88.88,5.77s.84,3.75,1.43,5.66c.54,1.86,1.24,3.68,2.09,5.42v.06c-.06.94-.09,1.84-.14,2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.41,
    y: 108.44,
    width: 60.51,
    height: 34.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m90.75,139.71h-54.14v-28h54.14v28Zm-54.01-.13h53.88v-27.74h-53.88v27.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12,187.36c-.1-1.43-.14-2.84-.2-4.25-.06-1.41-.1-2.83-.15-4.25-.07-2.83-.11-5.66-.15-8.49v-.49h13.82c2.22,0,4.44.09,6.66.16,1.11,0,2.22.09,3.33.13l3.34.16c-1.11.07-2.22.11-3.34.16-1.11.05-2.21.1-3.33.13-2.22.07-4.45.13-6.66.16s-4.45,0-6.66,0h-6.66l.49-.49c0,2.83-.07,5.66-.15,8.49,0,1.43-.07,2.84-.15,4.25-.07,1.41-.04,2.9-.19,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.53,170.38c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.14,4.24.07,2.84.11,5.66.15,8.5v.49h-7.23c-2.25,0-4.49,0-6.73-.06s-4.49-.07-6.74-.15l-3.36-.14-3.38-.15c1.12-.07,2.25-.13,3.38-.16l3.36-.14c2.25-.07,4.49-.11,6.74-.15,2.25-.04,4.49-.06,6.73-.06h6.74l-.49.5c0-2.84.06-5.66.14-8.5,0-1.41.09-2.83.15-4.24.06-1.41.11-2.81.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.83,184.15c-.07-1.76-.14-3.53-.16-5.29v-5.51h10.11c1.64,0,3.29,0,4.93.07,1.64.07,3.3.09,5,.15-1.64.06-3.29.13-5,.15-1.71.02-3.29.07-4.93.07h-9.88l.22-.22v5.29c-.22,1.76-.22,3.53-.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.7,173.58c.06,1.76.13,3.53.15,5.29.02,1.76.07,3.53.07,5.29v.22h-10.22c-1.66,0-3.33,0-5-.07-1.67-.07-3.33-.07-5-.15,1.66-.06,3.33-.11,5-.14,1.67-.02,3.33-.09,5-.09h10l-.24.22c0-1.76,0-3.53.07-5.29.07-1.76.09-3.53.16-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.74,184.15c-.06-1.76-.13-3.53-.15-5.29v-5.51h10.1c1.65,0,3.29,0,4.94.07l4.94.15c-1.65.06-3.3.13-4.94.15-1.64.02-3.29.07-4.94.07h-9.88l.22-.22v5.29c-.17,1.76-.24,3.53-.3,5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.65,173.58c0,1.76.13,3.53.15,5.29s.07,3.53.07,5.29v.22h-10.22c-1.66,0-3.33,0-5-.07-1.67-.07-3.33-.07-5-.15,1.66-.06,3.33-.11,5-.14,1.67-.02,3.33-.09,5-.09h10l-.22.22c0-1.76,0-3.53.07-5.29.07-1.76.05-3.53.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.91,187.36c-.09-1.43-.14-2.84-.2-4.25s-.1-2.83-.14-4.25c-.07-2.83-.13-5.66-.15-8.49v-.49h13.82c2.21,0,4.45.09,6.66.16,1.11,0,2.22.09,3.34.13l3.33.16c-1.1.07-2.21.11-3.33.16-1.11.05-2.22.1-3.34.13-2.21.07-4.44.13-6.66.16s-4.44,0-6.66,0h-6.66l.49-.49c0,2.83-.07,5.66-.14,8.49,0,1.43-.09,2.84-.15,4.25-.06,1.41-.13,2.9-.21,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.4,170.38c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.15,4.24.07,2.84.11,5.66.15,8.5v.49h-7.22c-2.24,0-4.49,0-6.74-.06s-4.49-.07-6.73-.15l-3.38-.14c-1.12,0-2.24-.09-3.36-.15,1.12-.07,2.24-.13,3.36-.16l3.38-.14c2.24-.07,4.49-.11,6.73-.15,2.24-.04,4.49-.06,6.74-.06h6.73l-.49.5c0-2.84.07-5.66.15-8.5,0-1.41.07-2.83.14-4.24.06-1.41.2-2.81.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.65,184.15c-.06-1.76-.13-3.53-.15-5.29v-5.51h10.03c1.65,0,3.29,0,5,.07,1.71.07,3.29.09,4.94.15-1.65.06-3.29.13-4.94.15-1.65.02-3.29.07-5,.07l-4.88.07h-4.94l.24-.22v5.29c-.17,1.69-.22,3.45-.3,5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.53,173.58c.07,1.76.13,3.53.16,5.29.04,1.76.06,3.53.07,5.29v.22h-10.24c-1.66,0-3.33,0-5-.07-1.67-.07-3.33-.07-5-.15,1.66-.06,3.33-.11,5-.14,1.67-.02,3.33-.09,5-.09h10l-.22.22c0-1.76,0-3.53.07-5.29.07-1.76.09-3.53.15-5.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.9,187.36c-.09-1.43-.14-2.84-.2-4.25s-.1-2.83-.15-4.25c-.07-2.83-.11-5.66-.15-8.49v-.49h13.82c2.22,0,4.44.09,6.66.16,1.11,0,2.22.09,3.33.13l3.34.16c-1.11.07-2.22.11-3.34.16-1.11.05-2.21.1-3.33.13-2.22.07-4.44.13-6.66.16s-4.45,0-6.66,0h-6.66l.49-.49c0,2.83-.07,5.66-.15,8.49,0,1.43-.07,2.84-.14,4.25s-.2,2.9-.2,4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.36,170.38c.09,1.41.14,2.83.2,4.25.06,1.42.1,2.83.14,4.24.07,2.84.13,5.66.15,8.5v.49h-7.23c-2.25,0-4.49,0-6.73-.06s-4.49-.07-6.74-.15l-3.36-.14-3.38-.15c1.12-.07,2.25-.13,3.38-.16l3.36-.14c2.25-.07,4.49-.11,6.74-.15,2.25-.04,4.49-.06,6.73-.06h6.74l-.49.5c0-2.84.06-5.66.14-8.5,0-1.41.09-2.83.15-4.24s.11-2.81.2-4.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.82,49.52l-4.58,4.91h4.58v2.35h-8.57v-2.35l4.57-4.91h-4.57v-2.35h8.57v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.65,51.98c0-3.24,2.06-4.97,5.18-4.97s5.15,1.72,5.15,4.97-2.06,4.97-5.15,4.97-5.18-1.72-5.18-4.97Zm5.18,2.61c1.18,0,2.03-.9,2.03-2.61,0-1.7-.85-2.61-2.03-2.61s-2.05.91-2.05,2.61.85,2.61,2.05,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m42.3,51.71v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m55.83,47.17v8.4c0,3.28-2.28,4.81-5.09,4.81-2.64,0-4.7-1.47-4.97-3.93h3.12c.21,1.1.89,1.61,1.84,1.61,1.2,0,1.97-.8,1.97-2.55v-.95c-.62.96-1.6,1.41-2.91,1.41-2.48,0-4.31-1.77-4.31-4.36s1.79-4.58,4.28-4.58c1.29,0,2.3.45,2.95,1.45v-1.3h3.12Zm-5.19,6.52c1.21,0,1.99-.89,1.99-2.09s-.79-2.15-1.99-2.15-2.04.86-2.04,2.13.79,2.11,2.04,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m60.28,47.17l2.06,6.44,2.06-6.44h3.46l-3.68,9.62h-3.68l-3.68-9.62h3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m77.81,49.65c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m82.64,51.71v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m94.73,49.52l-4.58,4.91h4.58v2.35h-8.57v-2.35l4.57-4.91h-4.57v-2.35h8.57v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m105.39,49.65c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m110.31,50.48l2.57-3.31h3.59l-3.79,4.81,3.83,4.81h-3.59l-2.61-3.29v3.29h-3.13v-12.79h3.13v6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m126.19,49.65c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m131.01,51.71v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m136.4,43c1.1,0,1.83.7,1.83,1.55s-.73,1.56-1.83,1.56-1.84-.7-1.84-1.56.73-1.55,1.84-1.55Zm1.56,13.78h-3.12v-9.62h3.12v9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m145.75,49.78c-.27-.28-.67-.43-1.18-.43-1.08,0-1.83.86-1.83,2v5.43h-3.13v-9.62h3.13v1.34c.5-.95,1.5-1.5,2.79-1.5s2.16.32,2.78.94c.7.66,1.03,1.67,1.03,2.99v5.85h-3.13v-5.53c0-.66-.15-1.15-.46-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m160.98,47.17v8.4c0,3.28-2.28,4.81-5.09,4.81-2.64,0-4.7-1.47-4.97-3.93h3.12c.21,1.1.89,1.61,1.84,1.61,1.2,0,1.97-.8,1.97-2.55v-.95c-.62.96-1.6,1.41-2.91,1.41-2.48,0-4.31-1.77-4.31-4.36s1.79-4.58,4.28-4.58c1.29,0,2.3.45,2.95,1.45v-1.3h3.12Zm-5.19,6.52c1.21,0,1.99-.89,1.99-2.09s-.79-2.15-1.99-2.15-2.04.86-2.04,2.13.79,2.11,2.04,2.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.82,49.52l-4.58,4.91h4.58v2.35h-8.57v-2.35l4.57-4.91h-4.57v-2.35h8.57v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.65,51.98c0-3.24,2.06-4.97,5.18-4.97s5.15,1.72,5.15,4.97-2.06,4.97-5.15,4.97-5.18-1.72-5.18-4.97Zm5.18,2.61c1.18,0,2.03-.9,2.03-2.61,0-1.7-.85-2.61-2.03-2.61s-2.05.91-2.05,2.61.85,2.61,2.05,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.3,51.71v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.83,47.17v8.4c0,3.28-2.28,4.81-5.09,4.81-2.64,0-4.7-1.47-4.97-3.93h3.12c.21,1.1.89,1.61,1.84,1.61,1.2,0,1.97-.8,1.97-2.55v-.95c-.62.96-1.6,1.41-2.91,1.41-2.48,0-4.31-1.77-4.31-4.36s1.79-4.58,4.28-4.58c1.29,0,2.3.45,2.95,1.45v-1.3h3.12Zm-5.19,6.52c1.21,0,1.99-.89,1.99-2.09s-.79-2.15-1.99-2.15-2.04.86-2.04,2.13.79,2.11,2.04,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.28,47.17l2.06,6.44,2.06-6.44h3.46l-3.68,9.62h-3.68l-3.68-9.62h3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.81,49.65c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.64,51.71v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.73,49.52l-4.58,4.91h4.58v2.35h-8.57v-2.35l4.57-4.91h-4.57v-2.35h8.57v2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.39,49.65c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.31,50.48l2.57-3.31h3.59l-3.79,4.81,3.83,4.81h-3.59l-2.61-3.29v3.29h-3.13v-12.79h3.13v6.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.18,49.65c.38.84.55,1.84.49,2.96h-7.16c.18,1.31.97,2.02,2.02,2.02.86,0,1.59-.45,1.84-1.42h3.11c-.38,2.46-2.4,3.73-4.95,3.73-3.11,0-5.18-1.73-5.18-4.97s2.07-4.97,5.19-4.97c2.27,0,3.89,1,4.64,2.64Zm-2.74,1.29c-.03-.16-.06-.3-.1-.44-.29-.81-.94-1.24-1.8-1.24-.98,0-1.69.59-1.96,1.68h3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.01,51.71v5.07h-3.13v-9.62h3.13v1.26c.57-.95,1.53-1.42,2.77-1.42v2.4c-1.87-.09-2.77.95-2.77,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.4,43c1.1,0,1.83.7,1.83,1.55s-.73,1.56-1.83,1.56-1.84-.7-1.84-1.56.73-1.55,1.84-1.55Zm1.56,13.78h-3.12v-9.62h3.12v9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.75,49.78c-.27-.28-.67-.43-1.18-.43-1.08,0-1.83.86-1.83,2v5.43h-3.13v-9.62h3.13v1.34c.5-.95,1.5-1.5,2.79-1.5s2.16.32,2.78.94c.7.66,1.03,1.67,1.03,2.99v5.85h-3.13v-5.53c0-.66-.15-1.15-.46-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.97,47.17v8.4c0,3.28-2.28,4.81-5.09,4.81-2.64,0-4.7-1.47-4.97-3.93h3.12c.21,1.1.89,1.61,1.84,1.61,1.2,0,1.97-.8,1.97-2.55v-.95c-.62.96-1.6,1.41-2.91,1.41-2.48,0-4.31-1.77-4.31-4.36s1.79-4.58,4.28-4.58c1.29,0,2.3.45,2.95,1.45v-1.3h3.12Zm-5.19,6.52c1.21,0,1.99-.89,1.99-2.09s-.79-2.15-1.99-2.15-2.04.86-2.04,2.13.79,2.11,2.04,2.11Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m46.51,133.12c-1.45.07-2.71-.44-3.79-1.55-1.04-1.07-1.59-2.33-1.67-3.79-.09-1.72.47-3.23,1.68-4.51,1.21-1.25,2.68-1.93,4.41-2.01,1.65-.08,3,.42,4.06,1.51,1.03,1.04,1.58,2.4,1.66,4.07.09,1.83-.8,3.42-2.69,4.78-1.3.95-2.53,1.45-3.68,1.51Zm.8-9.45c-1.25.06-2.41.58-3.49,1.55-.7.61-1.02,1.38-.97,2.31.04.75.42,1.4,1.14,1.94.69.54,1.42.78,2.18.75.53-.03,1.17-.2,1.91-.51.74-.31,1.3-.65,1.68-1.01.46-.44.75-.74.89-.91.3-.39.44-.78.42-1.15-.05-1.04-.44-1.81-1.18-2.33-.66-.48-1.52-.7-2.59-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m57.94,129.7c0,.1.02.25.04.45.02.2.03.35.04.45.02.5-.02.87-.12,1.11-.15.34-.45.52-.9.54-.32.02-.6-.04-.82-.18-.26-.16-.39-.39-.41-.7-.01-.28-.02-.54-.01-.8v-.77c.02-.66-.01-1.66-.08-3-.06-1.2-.15-2.36-.27-3.46-.47.15-.73.23-.77.23-.25.01-.46-.07-.64-.26-.18-.18-.28-.4-.29-.63-.02-.35.18-.6.6-.76,1.39-.51,2.97-.81,4.75-.9,1.08-.05,2.04.05,2.86.31,1.15.38,1.75,1.01,1.79,1.91.04.76-.32,1.65-1.08,2.67-.94,1.26-2.5,2.52-4.68,3.78Zm-.2-2.27c.86-.38,1.69-.91,2.47-1.57,1.01-.86,1.5-1.65,1.47-2.38-.04-.79-.77-1.15-2.19-1.08-.65.03-1.43.17-2.33.41l.58,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m74.7,128.57c.03.61-.16,1.04-.57,1.27-.65.35-1.71.73-3.2,1.12-1.31.34-2.44.58-3.4.71-.18.17-.41.25-.69.27-.29.01-.57-.05-.82-.19-.28-.16-.42-.39-.43-.68v-.07c-.03-.61-.04-1.53-.04-2.75,0-1.22.02-1.75.02-1.59-.06-1.19-.16-2.45-.31-3.78-.12.06-.24.09-.35.1-.37.02-.56-.18-.58-.59-.03-.66.42-1.15,1.38-1.46,2.22-.74,4.31-1.15,6.28-1.25.34-.02.61.09.82.31.21.22.32.52.34.87.02.45-.12.68-.43.7-.03,0-.12,0-.26-.03-.3-.03-.94-.02-1.92.03-1.13.06-2.29.28-3.5.68.08.58.18,1.46.31,2.63,1.67-.15,2.85-.49,3.55-1.02.17-.13.29-.19.38-.2.23-.01.43.12.6.38.16.23.24.48.26.73.02.32-.11.55-.37.69-.74.39-2.14.77-4.22,1.15.06.59.13,1.45.23,2.6,1.3-.06,2.32-.17,3.05-.3,1.16-.23,2.07-.62,2.75-1.16.19-.16.33-.24.43-.24.21-.01.38.12.52.39.11.22.17.44.19.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.09,131.72c-.6.03-1.02-.11-1.28-.42-2.08-1.03-4.11-3.28-6.07-6.75.26,2.21.41,3.85.46,4.91.03.55,0,.94-.06,1.18-.14.39-.43.6-.89.62-.32.02-.6-.05-.84-.21-.28-.16-.43-.39-.45-.69,0-.12,0-.35,0-.7l.02-.7c.02-.58,0-1.53-.07-2.84-.06-1.28-.13-2.25-.2-2.89-.01-.11-.05-.35-.1-.73-.04-.3-.07-.54-.08-.73-.02-.3.11-.55.36-.74.21-.17.48-.26.8-.27.22-.01.42.14.6.47.1.17.41.6.92,1.28,1.11,1.51,1.93,2.56,2.45,3.15,1.03,1.18,2.03,2.03,3,2.54-.01-.79-.04-1.58-.08-2.37.02.32-.01.12-.09-.6-.07-.63-.12-1.17-.16-1.62-.06-.72-.12-1.63-.18-2.72v-.07c-.02-.28.08-.53.29-.73.21-.2.45-.31.73-.33.39-.02.65.19.76.62l1.36,9.84c.05.95-.35,1.45-1.21,1.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZorgverzekeringOpen);
export default __webpack_public_path__ + "static/media/zorgverzekering-open.440d60703d818ec4b2a8b544af1e8c9c.svg";
export { ForwardRef as ReactComponent };